module.exports = __webpack_public_path__ + "fonts/LineIconsPro Regular.50db762.eot";